// extracted by mini-css-extract-plugin
export default {"UserName":"UserName_UserName__iRYh7","basicProfile":"UserName_basicProfile__TTt7w","spanLeft":"UserName_spanLeft__ahphw","spanRight":"UserName_spanRight__dDIiC"};